// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1gEqk","label":"Completed_label__3j9jI"};